/**
 * Predefined intro lines for the "extra e-mail text" field on rates +
 * invoices. Daniel always picks from this small canonical set; the
 * "Andet (skriv selv)" option is the freeform escape.
 *
 * Source of truth — imported by Rates view, Billing view, and the
 * EmailTextSelect inline component. Adding a new preset here propagates
 * to every consumer automatically.
 *
 * `value` is the dropdown's bound key (NOT stored). `text` is what gets
 * persisted to email_custom_text. Match an existing value back to a
 * preset by exact text equality; no match → __OTHER__ + textarea.
 */
export const RATE_EMAIL_PRESETS = [
  {
    value: 'opstart',
    label: 'Opstart',
    text: 'Ifbm. opstart af dit projekt er her din faktura',
  },
  {
    value: 'optagelse',
    label: 'Optagelsesdag',
    text: 'Ifbm. afholdt optagelsesdag er her din faktura',
  },
  {
    value: 'revision',
    label: 'Revision & færdig',
    text: 'Ifbm. revision & færdiggørelse af projektet er her din faktura',
  },
  {
    value: 'bestilling',
    label: 'Bestilling',
    text: 'I forlængelse af jeres bestilling fremsender vi hermed faktura',
  },
  {
    value: '__OTHER__',
    label: 'Andet (skriv selv)…',
    text: '',
  },
] as const;

export type RateEmailPresetValue = (typeof RATE_EMAIL_PRESETS)[number]['value'];

/**
 * Resolve a stored email_custom_text back to the dropdown value that
 * should appear selected. Empty/null → '' (placeholder). Exact-text
 * preset match → its `value`. Anything else → '__OTHER__'.
 */
export function resolveEmailPresetValue(stored: string | null | undefined): string {
  if (stored === null || stored === undefined || stored === '') return '';
  for (const p of RATE_EMAIL_PRESETS) {
    if (p.value === '__OTHER__') continue;
    if (p.text === stored) return p.value;
  }
  return '__OTHER__';
}
